var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.45,11.83h1.1l3-2L21,9V6l-.45-.83-3-2h-1.1l-3,2L13,6V9l.45.83ZM15,6.54,17,5.2l2,1.34V8.46L17,9.8,15,8.46Zm7.89,10-1.78.9-.86-1.7L18.76,15H15.24l-1.49.75-.86,1.7-1.78-.9,1-2,.44-.44,2-1L15,13h4l.45.11,2,1,.44.44Zm-11,2,1,2-1.78.9-.86-1.7L8.76,19H5.24l-1.49.75-.86,1.7-1.78-.9,1-2,.44-.44,2-1L5,17H9l.45.11,2,1ZM6.45,15.83h1.1l3-2L11,13V10l-.45-.83-3-2H6.45l-3,2L3,10v3l.45.83ZM5,10.54,7,9.2l2,1.34v1.92L7,13.8,5,12.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/1765983986/media/icon-users.36661c6ad826569e4864e28968e009b7.svg";
export { ForwardRef as ReactComponent };